import { render, staticRenderFns } from "./AreaHomePage.vue?vue&type=template&id=64982074&"
import script from "./AreaHomePage.vue?vue&type=script&lang=js&"
export * from "./AreaHomePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports